import { CHECK_CODE } from '../actionTypes'

export const checkCode = (commonCode: string) => ({
  type: CHECK_CODE.name,
  api: {
    url: 'wedding/check_code',
    data: { common_code: commonCode },
  },
})
